import { DistributionRequestStatus } from '../../types';
import AnchorAPIError from './AnchorAPIError';

export type PodcastUrlDictionary = {
  [platform: string]: string;
};
export type FetchPodcastStatusResponse = {
  isAutoPairable: boolean;
  isRedirectedToAnchor: boolean;
  podcastStatus: DistributionRequestStatus | null;
  podcastUrlDictionary: PodcastUrlDictionary | {};
  vanitySlug: string;
  podcastExternalSource?: string;
};

type FetchPodcastStatusParams = {
  userId: number;
};

async function fetchPodcastStatus({
  userId,
}: FetchPodcastStatusParams): Promise<FetchPodcastStatusResponse> {
  try {
    const response = await fetch(
      `/api/proxy/v3/stations/status?userId=${userId}`,
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return response.json();
    }
    throw new AnchorAPIError(
      response,
      `Non 200 response status: ${response.status}`
    );
  } catch (err) {
    throw new Error(err.messages);
  }
}

export { fetchPodcastStatus };
